var zo = zo || {};


// Home fold slider 
//-----------------------------------------------------------------
zo.foldSlider = function() {

    var $slider = $('.js_foldSlider').removeClass('loading');

    if (!$slider.length) {
        return;
    }

    $slider.slick({
        autoplay: true,
        fade: true,
        speed: 1000,
        infinite: true,
        dots: true,
        arrows: true,
        adaptiveHeight: false,
        slide: '.fold__item',
        appendDots: $('.fold__dots'),
        appendArrows: $('.fold__arrows'),
        touchThreshold: 12,
        prevArrow: '<a class="fold__arrows_item arrow-prev"><i class="icon-arrow-small-left"></i></a>',
        nextArrow: '<a class="fold__arrows_item arrow-next"><i class="icon-arrow-small-right"></i></a>',
        cssEase: 'cubic-bezier(.84,.2,.6,1.04)'
    });

};


zo.foldPartners = function() {

    var $slider = $('.foldPartners').removeClass('loading');

    if (!$slider.length) {
        return;
    }

    $slider.slick({
        autoplay: true,
        autoplaySpeed: 5000,
        arrows: true,
        dots: false,
        slidesToShow: 5,
        slidesToScroll: 1,
        focusOnSelect: false,
        accessibility: false,
        infinite: true,
        centerMode: true,
        centerPadding: 0,
        touchThreshold: 12,
        slide: '.fold__item',
        // appendDots: $('.fold__dots'),
        prevArrow: '<a class="fold__arrows_item arrow-prev"><i class="icon-arrow-small-left"></i></a>',
        nextArrow: '<a class="fold__arrows_item arrow-next"><i class="icon-arrow-small-right"></i></a>',
        cssEase: 'cubic-bezier(.84,.2,.6,1.04)',
        responsive: [
            {
                breakpoint: 1400,
                settings: {
                    slidesToShow: 4
                 
                }
            },
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 3    
                }
            },       
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 2
                }
            },            
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1
                }
            }           
        ]
    });
};


// sw.testimonialsSlider = function() {

//     var $slider = $('.js_testimonialsSlider').removeClass('visuallyhidden');

//     if (!$slider.length) {
//         return;
//     }

//     $slider.slick({
//         mobileFirst: true,
//         autoplay: true,
//         autoplaySpeed: 5000,
//         arrows: false,
//         dots: true,
//         slidesToShow: 1,
//         slidesToScroll: 1,
//         focusOnSelect: true,
//         accessibility: false,
//         centerMode: true,
//         centerPadding: 0,
//         slide: '.testimonials__item',
//         appendDots: $('.testimonials__dots'),
//          responsive: [
//             {
//               breakpoint: 1024,
//               settings: {
//                 slidesToShow: 2
//               }
//             }
//         ]
       
//     });

// };




$(document).ready(function (){
    zo.foldSlider();
    zo.foldPartners();
});



